<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 처리상태-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001331') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--클레임 No.-->
							<th class="col-1">{{ getMessage_('QWCC001225') }}</th>
							<td class="col-1"><el-input v-model="clmNo" readOnly /></td>

							<!--클레임 처리단계-->
							<th class="col-1">{{ getMessage_('QWCC002033') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepClNm" readOnly />
							</td>

							<!--클레임 신청일-->
							<th class="col-1">{{ getMessage_('QWCC002034') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdCl" readOnly />
							</td>
							<!--클레임 확정일-->
							<th class="col-1">{{ getMessage_('QWCC001226') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdCl" readOnly />
							</td>

							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
						<tr>
							<!--이의제기타입-->
							<th class="col-1">* {{ getMessage_('QWCC001412') }}</th>
							<td class="col-1">
								<el-select v-model="mkobType" @change="changeMkObtype" :disabled="mkObjDisable">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in mkobTypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<!--이이제기 처리단계-->
							<th class="col-1">{{ getMessage_('QWCC002040') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNmObj" readOnly />
							</td>
							<!--이이제기 신청일-->
							<th class="col-1">{{ getMessage_('QWCC002041') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdObj" readOnly />
							</td>

							<!--이이제기 확정일-->
							<th class="col-1">{{ getMessage_('QWCC002042') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdObj" readOnly />
							</td>

							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
						<tr>
							<!--이의제기 사유 -->
							<th class="col-1">* {{ getMessage_('QWCC001471') }}</th>
							<td class="col-5" colspan="5">
								<el-input v-model="mkobRson" :readonly="mkObjPopUp.readOnlyAuth" />
							</td>
							<th class="col-1"></th>
							<td class="col-1"></td>

							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>

						<tr>
							<!-- 협력사-->
							<th class="col-1">* {{ getMessage_('QWCC001341') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="bflCpnyCd" class="inputWithIcon" @keyup.native.delete="onDelerInPutKeyDown()" readonly></el-input>
											<i class="icon-sf-search search-icon"></i>
										</div>
									</el-col>
								</div>
							</td>

							<td class="col-2" colspan="2">
								<!--협력사명-->
								<el-input v-model="bflCpnyNm" :placeholder="getMessage_('QWCC001342')" readonly />
							</td>

							<!-- 협력사 실납품사-->
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<td class="col-1"><el-input v-model="bflDlvgNm" readOnly /></td>
							<th class="col-1"></th>
							<td class="col-1"></td>
							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
						<tr>
							<!--협력사 분담율/귀책율 -->
							<th class="col-1">{{ getMessage_('QWCC001980') }}</th>
							<td class="col-1">
								<el-input v-model="bflDvswRt1" readOnly />
							</td>

							<!--변제금액 -->
							<th class="col-1">{{ getMessage_('QWCC001295') }}</th>
							<td class="col-1">
								<el-input v-model="bflRpymAmt1" readOnly />
							</td>

							<!--협력사 적용 분담율/귀책율 -->
							<th class="col-1">* {{ getMessage_('QWCC001981') }}</th>
							<td class="col-1">
								<!--<el-input :value="bflDvswRt2" @input="changebflDvswRt" maxlength="5" :readonly="aplInputCpnyCdDisable2" />-->

								<el-input :value="bflDvswRt2" @input="val => changebflDvswRt(val)" maxlength="5" :readonly="aplInputCpnyCdDisable2" />
							</td>

							<!--적용 변제금액 -->
							<th class="col-1">* {{ getMessage_('QWCC001306') }}</th>
							<td class="col-1">
								<el-input :value="bflRpymAmt2" :readonly="aplInputCpnyCdDisable2" @input="val => changeinput1(val)" />
							</td>

							<th class="col-1"></th>
							<td class="col-1"></td>
							<!--
							<td class="col-1">
								<el-input :value="bflDvswRt2" @input="changebflDvswRt" maxlength="5" :readonly="mkObjPopUp.readOnlyAuth" />
							</td>
							-->

							<!--
							<td class="col-1">
								<el-input :value="aplDvswRt2" @input="changeAplDvswRt" maxlength="5" :readonly="mkObjPopUp.readOnlyAuth" />
							</td>
							-->
						</tr>
						<tr>
							<!-- 확정 협력사-->
							<th class="col-1">* {{ getMessage_('QWCC001948') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="aplCpnyCd"
												class="inputWithIcon"
												@keyup.native.delete="onDelerInPutKeyDown1()"
												:readonly="aplCpnyCdDisable"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onDelerConPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<!--확정 협력사명-->
								<el-input v-model="aplCpnyNm" :placeholder="getMessage_('QWCC001949')" readonly />
							</td>

							<!-- 실납품사-->
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<td class="col-1"><el-input v-model="aplDlvgNm" readOnly /></td>

							<!--적용 변제금액 -->
							<th class="col-1">* {{ getMessage_('QWCC001306') }}</th>
							<td class="col-1">
								<!--<el-input v-model="aplRpymAmt2" maxlength="10" :readonly="aplInputCpnyCdDisable1" />-->
								<el-input :value="aplRpymAmt2" :readonly="aplInputCpnyCdDisable1" @input="val => changeinput2(val)" />
							</td>
							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
						<tr>
							<!--원인부품-->
							<th class="col-1">* {{ getMessage_('QWCC001028') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="aplCausPartNo" class="inputWithIcon" readonly></el-input>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="aplCausPartNm" :placeholder="getMessage_('QWCC000957')" readonly />
							</td>
							<th class="col-1"></th>
							<td class="col-1"></td>
							<th class="col-1"></th>
							<td class="col-1"></td>

							<!--확정 협력사 분담율
							<th class="col-1">{{ getMessage_('QWCC001980') }}</th>
							<td class="col-1">
								<el-input v-model="aplDvswRt1" readOnly />
							</td>
							변제금액
							<th class="col-1">{{ getMessage_('QWCC001295') }}</th>
							<td class="col-1">
								<el-input v-model="aplRpymAmt1" readOnly />
							</td>
							
							확정 협력사 적용 분담율 
							<th class="col-1">* {{ getMessage_('QWCC001981') }}</th>
							<td class="col-1">
								
								<el-input :value="aplDvswRt2" @input="val => changeAplDvswRt(val)" maxlength="5" :readonly="aplInputCpnyCdDisable1" />
							</td>
							-->

							<th class="col-1"></th>
							<td class="col-1"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object },
		sendParam2: { type: Object }
	},
	components: {},
	data() {
		return {
			clmNo: '', //클래임번호
			nos: '',
			tgrpYn: '', //클레임 변제대상
			mkobType: '', //이의제기타입
			prcsStepObj: '', //이의제기 처리단계
			prcsRsltObj: '', //이의제기 처리결과
			prcsStepNmObj: '', //이의제기 처리단계명
			prcsRsltNmObj: '', //이의제기 처리결과명
			aplcDdObj: '', //이의제기 신청일자(제기일)
			dcsnDdObj: '', //이의제기 적용일(완료일)
			mkobRson: '', //이의제기 사유

			aplCpnyCd: '', //확정 협력사업체코드
			aplCpnyNm: '', //확정 협력사업체명
			bflCpnyCd: '', //협력사코드(이전)
			bflCpnyNm: '', //협력사명(이전)
			bflDvswRt1: '', //협력사(이전) 분담율
			bflDvswRt2: '', //협력사(이전) 적용 분담율
			bflRpymAmt1: '', //협력사 변제금액
			bflRpymAmt2: '', //협력사 적용변제금액

			aplDvswRt1: '', //확정 협력사 분담율
			aplDvswRt2: '', //확정 협력사 적용분담율

			aplRpymAmt1: '', //확정 협력사 적용변제금액
			aplRpymAmt2: '', //확정 협력사 적용변제금액

			dcsnDdCl: '',
			aplcDdCl: '',
			prcsStepClNm: '',
			prcStepCl: '',
			bflDlvgNm: '', //실납품사
			aplDlvgNm: '', //협력사 확정 실납품사
			aplCausPartNo: '', //협력사 확정 부품번호
			aplCausPartNm: '', //협력사 확정 부품명

			rmk: '', //비고
			cpnyNm: '', //납품업체 팝업시 필요함

			tmpBflDvswRt2: '', //협력사 적용 분담율/귀책율 임시저장함
			tmpBflRpymAmt2: '', //협력사 적용 변제금액 임시저장함

			tmpBflDvswRt1: '0', //협력사 제품결함 선택시 적용 분담율/귀책율  선택시 초기값 0
			tmpBflRpymAmt1: '0' //협력사 제품결함 선택시 적용
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		},
		bflCpnyCdDisable() {
			let tmpCmPnNo = convertNvl(this.mkObjPopUp.cmpnNo, '');
			if (this.mkObjPopUp.readOnlyAuth == true || this.mkObjPopUp.mkobType == 10 || tmpCmPnNo != '') {
				return true;
			} else {
				return false;
			}
		},
		aplCpnyCdDisable() {
			if (this.mkObjPopUp.mkobType == 10 && this.mkObjPopUp.readOnlyAuth == false) {
				return false;
			} else {
				return true;
			}
		},
		aplInputCpnyCdDisable1() {
			if (this.mkObjPopUp.mkobType == 10 && this.mkObjPopUp.readOnlyAuth == false) {
				return false;
			} else {
				return true;
			}
		},
		aplInputCpnyCdDisable2() {
			//console.log('뭐냐1?>>>', this.mkObjPopUp.readOnlyAuth);
			//console.log('뭐냐2?>>>', this.mkObjPopUp.readOnlyAuth1);
			//console.log('뭐냐4?>>>', this.mkObjPopUp.mkobType);

			let mkobType = convertNvl(this.mkObjPopUp.mkobType, '');

			//신청단계
			if (this.mkObjPopUp.readOnlyAuth1 == false) {
				if (mkobType == '' || mkobType == 10) {
					//console.log('막혀야되');
					return true;
				} else {
					//console.log('풀려야되');
					return false;
				}
			} else {
				return true;
			}
		},
		mkObjDisable() {
			let tmpCmPnNo = convertNvl(this.mkObjPopUp.cmpnNo, '');

			if (this.mkObjPopUp.readOnlyAuth1 == true || tmpCmPnNo != '') {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeMkObtype(value) {
			//console.log('>><>>>', value);
			this.setStateMkObjPopUp_({ key: 'mkobType', value: convertNvl(value, '') }); //클레임 변제대상

			this.setStateMkObjPopUp_({ key: 'aplCpnyCd', value: '' }); //클레임 변제대상
			this.setStateMkObjPopUp_({ key: 'aplCpnyNm', value: '' }); //클레임 변제대상
			//this.setStateMkObjPopUp_({ key: 'aplDvswRt1', value: '' }); //클레임 변제대상
			//this.setStateMkObjPopUp_({ key: 'aplDvswRt2', value: '' }); //클레임 변제대상
			//this.setStateMkObjPopUp_({ key: 'aplRpymAmt1', value: '' }); //클레임 변제대상
			this.setStateMkObjPopUp_({ key: 'aplRpymAmt2', value: '' }); //클레임 변제대상

			this.aplCpnyCd = ''; //확정 협력사 납품업체
			this.aplCpnyNm = ''; //확정 협력사 납품업체명
			this.aplDvswRt1 = ''; //이의제기 확정 협력사 분담율
			this.aplDvswRt2 = ''; //이의제기 확정 협력사 적용분담율
			this.aplRpymAmt1 = ''; //이의제기 확정 협력사 변제금액
			this.aplRpymAmt2 = ''; //이의제기 확정 협력사 변제금액

			this.aplDlvgNm = ''; //협력사 확정 실납품사
			this.aplCausPartNo = ''; //협력사 확정 부품번호
			this.aplCausPartNm = ''; //협력사 확정 부품명
			this.setStateMkObjPopUp_({ key: 'aplDlvgNm', value: '' }); //클레임 변제대상
			this.setStateMkObjPopUp_({ key: 'aplCausPartNo', value: '' }); //클레임 변제대상
			this.setStateMkObjPopUp_({ key: 'aplCausPartNm', value: '' }); //클레임 변제대상

			if (value == '30') {
				//제품결함 선택
				this.bflDvswRt2 = this.tmpBflDvswRt1; //제품결함시 확정 분담율을 0으로 셋팅한다.
				this.bflRpymAmt2 = this.tmpBflRpymAmt1; //협력사 확정 변제금액을 0으로 셋팅한다.
			} else if (value == '10') {
				this.aplRpymAmt2 = this.bflRpymAmt2; //적용변제금액
			} else {
				this.bflDvswRt2 = this.tmpBflDvswRt2; //협력사 적용 분담율
				this.bflRpymAmt2 = this.tmpBflRpymAmt2; //협력사 적용 변제금액
			}
		},
		setProcessInfo() {
			this.clmNo = this.mkObjPopUp.clmNo; //클레임번호
			this.nos = this.mkObjPopUp.nos; //차수
			this.tgrpYn = this.mkObjPopUp.tgrpYn; // 클레임 변제대상
			this.mkobType = this.mkObjPopUp.mkobType; // 이의제기 타입

			this.prcsStepObj = this.mkObjPopUp.prcsStepObj; //이의제기 처리단계
			this.prcsRsltObj = this.mkObjPopUp.prcsRsltObj; //이의제기 처리결과
			this.prcsStepNmObj = this.mkObjPopUp.prcsStepNmObj; //이의제기 처리단계명
			this.prcsRsltNmObj = this.mkObjPopUp.prcsRsltNmObj; //이의제기 처리결과명
			this.aplcDdObj = this.mkObjPopUp.aplcDdObj; //이의제기 신청일자(제기일)
			this.dcsnDdObj = this.mkObjPopUp.dcsnDdObj; //이의제기 적용일(완료일)
			this.mkobRson = this.mkObjPopUp.mkobRson; //이의제기 사유

			this.bflCpnyCd = this.mkObjPopUp.bflCpnyCd; //이의제기 협력사
			this.bflCpnyNm = this.mkObjPopUp.bflCpnyNm; //이의제기 협력사명

			this.bflDvswRt1 = this.mkObjPopUp.bflDvswRt1; //이의제기 협력사 분담율
			this.bflDvswRt2 = this.mkObjPopUp.bflDvswRt2; //이의제기 협력사 적용분담율
			this.bflRpymAmt1 = this.mkObjPopUp.bflRpymAmt1; //이의제기 협력사 변제금액
			this.bflRpymAmt2 = this.mkObjPopUp.bflRpymAmt2; //이의제기 협력사 변제금액

			this.tmpBflDvswRt2 = this.mkObjPopUp.bflDvswRt2; //이의제기 협력사 적용분담율,
			this.tmpBflRpymAmt2 = this.mkObjPopUp.bflRpymAmt2; //이의제기 협력사 적용분담율 ''

			this.aplCpnyCd = this.mkObjPopUp.aplCpnyCd; //확정 협력사 납품업체
			this.aplCpnyNm = this.mkObjPopUp.aplCpnyNm; //확정 협력사 납품업체명
			this.aplDvswRt1 = this.mkObjPopUp.aplDvswRt1; //이의제기 확정 협력사 분담율
			this.aplDvswRt2 = this.mkObjPopUp.aplDvswRt2; //이의제기 확정 협력사 적용분담율
			this.aplRpymAmt1 = this.mkObjPopUp.aplRpymAmt1; //이의제기 확정 협력사 변제금액
			this.aplRpymAmt2 = this.mkObjPopUp.aplRpymAmt2; //이의제기 확정 협력사 변제금액

			this.prcStepCl = this.mkObjPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.mkObjPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.mkObjPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.mkObjPopUp.dcsnDdCl; //확정일
			this.rmk = this.mkObjPopUp.rmk; //비고
			this.bflDlvgNm = this.mkObjPopUp.bflDlvgNm; //협력사 실납품사
			this.aplDlvgNm = this.mkObjPopUp.aplDlvgNm; //협력사 확정 실납품사

			this.aplCausPartNo = this.mkObjPopUp.aplCausPartNo; //협력사 확정 부품번호
			this.aplCausPartNm = this.mkObjPopUp.aplCausPartNm; //협력사 확정 부품명
		},
		onDelerInPutKeyDown1() {
			this.aplCpnyCd = '';
			this.aplCpnyNm = '';

			//this.aplDvswRt1 = ''; //이의제기 확정 협력사 분담율
			//this.aplDvswRt2 = ''; //이의제기 확정 협력사 적용분담율
			//this.aplRpymAmt1 = ''; //이의제기 확정 협력사 변제금액
			this.aplRpymAmt2 = ''; //이의제기 확정 협력사 변제금액

			this.aplCausPartNo = ''; //협력사 확정 부품번호
			this.aplCausPartNm = ''; //협력사 확정 부품명

			//분담율
			//this.dvswRt = '';
			//적용분담율
			//this.aplDvswRt = '';
		},

		onDelerInPutKeyDown() {
			this.bflCpnyCd = '';
			this.bflCpnyNm = '';

			//분담율
			this.bflDvswRt1 = '';
			//적용분담율
			this.bflDvswRt2 = '';

			this.bflDvswRt1 = ''; //이의제기 협력사 분담율
			this.bflDvswRt2 = ''; //이의제기 협력사 적용분담율

			this.bflRpymAmt1 = ''; //이의제기  협력사 변제금액
			this.bflRpymAmt2 = ''; //이의제기 협력사 변제금액
		},
		onDelerPopup() {
			/*딜러팝업*/
			let tmpCmPnNo = convertNvl(this.mkObjPopUp.cmpnNo, '');

			if (this.mkObjPopUp.readOnlyAuth == false) {
				if (this.mkObjPopUp.mkobType == 10 || tmpCmPnNo != '') {
					return false;
				}

				let paramValue = {
					//행추가 이벤트시 필요한부분
					cpnyNm: this.bflCpnyNm, //협력사명
					roNo: this.mkObjPopUp.roNo, //ro번호
					causPartNo: this.mkObjPopUp.causPartNo, //원인부품번호
					cmpnNo: this.mkObjPopUp.cmpnNo, //캠페인번호
					calRpymAmtGb: true
				};

				this.$emit('OpenDelPopup', paramValue);
			}
		},
		onDelerConPopup() {
			/*딜러팝업*/
			let tmpCmPnNo = convertNvl(this.mkObjPopUp.cmpnNo, '');
			if (this.mkObjPopUp.readOnlyAuth == false) {
				if (this.mkObjPopUp.mkobType != 10) {
					return false;
				}

				let paramValue = {
					//행추가 이벤트시 필요한부분
					cpnyNm: this.aplCpnyNm, //협력사명
					roNo: this.mkObjPopUp.roNo, //ro번호
					causPartNo: this.mkObjPopUp.causPartNo, //원인부품번호
					cmpnNo: this.mkObjPopUp.cmpnNo, //캠페인번호
					calRpymAmtGb: true
				};

				this.$emit('OpenConfirmDelPopup', paramValue);
			}
		},
		setClearInfo() {
			//납품업체코드
			this.aplCpnyCd = '';
			//납품업체명
			this.aplCpnyNm = '';

			//분담율
			this.dvswRt = '';
			//적용분담율
			this.aplDvswRt = '';

			this.mkobType = ''; //이의제기타입
			this.mkobRson = ''; //이의제기사유
			this.rmk = ''; //비고
		},
		async changebflDvswRt(value) {
			//협력사 적용분담율계산

			value = value.replace(/[^\.0-9]/g, '');
			const arr = value.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (value.length > 16) {
					value = value.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				value = arr.reduce((a, b) => a + b);
			}

			this.bflDvswRt2 = value;
			try {
				if (value > 100) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001776'), [this.getMessage_('QWCC001305')]));
					return false;
				} else {
					let tmpAplCpnyCd = convertNvl(this.bflCpnyCd, '');
					let inputValue = convertNvl(value, '');

					if (tmpAplCpnyCd == '') {
						throw new Error(this.getMessage_('QWCC001987')); // 협력사를 선택해주세요.
					}

					//console.log('입력된분담율', value);

					if (inputValue == '') {
						this.bflRpymAmt2 = '';
						return false;
					} else if (inputValue == '.') {
						inputValue = 0.0;
						this.bflDvswRt2 = 0.0;
					}

					let paramValue = {
						cpnyCd: convertNvl(this.bflCpnyCd, ''), //협력사
						roNo: convertNvl(this.mkObjPopUp.roNo, ''), //ro번호
						causPartNo: convertNvl(this.mkObjPopUp.causPartNo, ''), //원인부품번호
						cmpnNo: convertNvl(this.mkObjPopUp.cmpnNo, ''), //캠페인번호
						disPlayGb: convertNvl('mkObj1', ''), //캠페인번호
						rtsh: inputValue
					};

					await this.getCalAplRpymAmt1_(paramValue);

					this.setAplRpymAmtInfo1();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async changeAplDvswRt(value) {
			//협력사 적용분담율

			value = value.replace(/[^\.0-9]/g, '');
			const arr = value.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (value.length > 16) {
					value = value.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				value = arr.reduce((a, b) => a + b);
			}

			this.aplDvswRt2 = value;

			try {
				if (value > 100) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001776'), [this.getMessage_('QWCC001305')]));
				} else {
					//let tmpAplRpyAmt = convertNvl(value, '') == '' ? '' : (Number.parseInt(value) / 100) * Number.parseInt(this.rpymAmt);

					//적용변제금액  = (적용분담율 /100) * 변제금액  절삭해서 넣는다.소수점 없이.
					//this.aplRpymAmt = Math.floor(tmpAplRpyAmt);

					let tmpAplCpnyCd = convertNvl(this.bflCpnyCd, '');
					let inputValue = convertNvl(value, '');

					if (tmpAplCpnyCd == '') {
						throw new Error(this.getMessage_('QWCC001987')); //협력사를 선택해 주세요.
					}

					//console.log('입력된분담율', value);

					if (inputValue == '') {
						this.aplRpymAmt2 = '';
						return false;
					} else if (inputValue == '.') {
						inputValue = 0.0;
						this.aplDvswRt2 = 0.0;
					}

					let paramValue = {
						cpnyCd: convertNvl(this.bflCpnyCd, ''), //협력사
						roNo: convertNvl(this.mkObjPopUp.roNo, ''), //ro번호
						causPartNo: convertNvl(this.mkObjPopUp.causPartNo, ''), //원인부품번호
						cmpnNo: convertNvl(this.mkObjPopUp.cmpnNo, ''), //캠페인번호
						disPlayGb: convertNvl('mkObj2', ''), //캠페인번호
						rtsh: inputValue
					};

					await this.getCalAplRpymAmt2_(paramValue);

					this.setAplRpymAmtInfo2();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		setAplRpymAmtInfo1() {
			this.bflRpymAmt2 = this.mkObjPopUp.bflRpymAmt2; //적용변제금액
		},
		setAplRpymAmtInfo2() {
			this.aplRpymAmt2 = this.mkObjPopUp.aplRpymAmt2; //적용변제금액
		},
		changeinput1(val) {
			val = val.replace(/[^-\.0-9]/g, '');
			const arr = val.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (val.length > 16) {
					val = val.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				val = arr.reduce((a, b) => a + b);
			}

			this.bflRpymAmt2 = val;

			/*적용분담율 재계산한다.*/
			//적용변제금액 * 귀책율(분담율) / 변제금액
			const bflDvswRt = (this.bflRpymAmt2 * this.bflDvswRt1) / this.bflRpymAmt1;
			const result = Math.round((bflDvswRt + Number.EPSILON) * 100) / 100;
			this.bflDvswRt2 = isNaN(result) == true ? 0 : result;
		},

		changeinput2(val) {
			val = val.replace(/[^-\.0-9]/g, '');
			const arr = val.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (val.length > 16) {
					val = val.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				val = arr.reduce((a, b) => a + b);
			}

			this.aplRpymAmt2 = val;

			/*적용분담율 재계산한다.*/
			//적용변제금액 * 귀책율(분담율) / 변제금액
			const aplDvswRt = (this.aplRpymAmt2 * this.aplDvswRt1) / this.aplRpymAmt1;
			const result = Math.round((aplDvswRt + Number.EPSILON) * 100) / 100;
			this.aplDvswRt2 = isNaN(result) == true ? 0 : result;
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		try {
			await this.getCommCodes_({ key: 'mkobTypeList', codeType: 'MKOB_TYPE' });

			this.clmNo = this.mkObjPopUp.clmNo; //클레임번호
			this.tgrpYn = this.mkObjPopUp.tgrpYn; // 클레임 변제대상
			this.mkobType = this.mkObjPopUp.mkobType; // 이의제기타입

			this.nos = this.mkObjPopUp.nos; //차수

			this.prcsStepObj = this.mkObjPopUp.prcsStepObj; //이의제기 처리단계
			this.prcsRsltObj = this.mkObjPopUp.prcsRsltObj; //이의제기 처리결과
			this.prcsStepNmObj = this.mkObjPopUp.prcsStepNmObj; //이의제기 처리단계명
			this.prcsRsltNmObj = this.mkObjPopUp.prcsRsltNmObj; //이의제기 처리결과명
			this.aplcDdObj = this.mkObjPopUp.aplcDdObj; //이의제기 신청일자(제기일)
			this.dcsnDdObj = this.mkObjPopUp.dcsnDdObj; //이의제기 적용일(완료일)
			this.mkobRson = this.mkObjPopUp.mkobRson; //이의제기 사유

			this.aplCpnyCd = this.mkObjPopUp.aplCpnyCd; //납품업체
			this.aplCpnyNm = this.mkObjPopUp.aplCpnyNm; //납품업체명
			this.dvswRt = this.mkObjPopUp.dvswRt; //분담율
			this.aplDvswRt = this.mkObjPopUp.aplDvswRt; //적용분담율
			this.rpymAmt = this.mkObjPopUp.rpymAmt; //변제금액
			this.aplRpymAmt = this.mkObjPopUp.aplRpymAmt; //적용변제금액
			this.rmk = this.mkObjPopUp.rmk; //비고

			this.prcStepCl = this.mkObjPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.mkObjPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.mkObjPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.mkObjPopUp.dcsnDdCl; //확정일

			this.bflCpnyCd = this.mkObjPopUp.bflCpnyCd; //이의제기 협력사
			this.bflCpnyNm = this.mkObjPopUp.bflCpnyNm; //이의제기 협력사명

			this.bflDvswRt1 = this.mkObjPopUp.bflDvswRt1; //이의제기 협력사 분담율
			this.bflDvswRt2 = this.mkObjPopUp.bflDvswRt2; //이의제기 협력사 적용분담율
			this.bflRpymAmt1 = this.mkObjPopUp.bflRpymAmt1; //이의제기 협력사 변제금액
			this.bflRpymAmt2 = this.mkObjPopUp.bflRpymAmt2; //이의제기 협력사 변제금액

			this.aplCpnyCd = this.mkObjPopUp.aplCpnyCd; //확정 협력사 납품업체
			this.aplCpnyNm = this.mkObjPopUp.aplCpnyNm; //확정 협력사 납품업체명
			this.aplDvswRt1 = this.mkObjPopUp.aplDvswRt1; //이의제기 확정 협력사 분담율
			this.aplDvswRt2 = this.mkObjPopUp.aplDvswRt2; //이의제기 확정 협력사 적용분담율
			this.aplRpymAmt1 = this.mkObjPopUp.aplRpymAmt1; //이의제기 확정 협력사 변제금액
			this.aplRpymAmt2 = this.mkObjPopUp.aplRpymAmt2; //이의제기 확정 협력사 변제금액
			this.bflDlvgNm = this.mkObjPopUp.bflDlvgNm; //실납품사
			this.aplDlvgNm = this.mkObjPopUp.aplDlvgNm; //협력사 확정 실납품사
			this.aplCausPartNo = this.mkObjPopUp.aplCausPartNo; //협력사 확정 부품번호
			this.aplCausPartNm = this.mkObjPopUp.aplCausPartNm; //협력사 확정 부품명

			this.tmpBflDvswRt2 = this.mkObjPopUp.bflDvswRt2; //이의제기 협력사 적용분담율,
			this.tmpBflRpymAmt2 = this.mkObjPopUp.bflRpymAmt2; //이의제기 협력사 적용변제금액
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		sendParam1(newValue, oldValue) {
			//딜러점
			this.bflCpnyCd = this.sendParam1.cpnyCd;
			this.bflCpnyNm = this.sendParam1.cpnyNm;

			let tmpDvswRt = this.sendParam1.rtsh;

			//분담율
			this.bflDvswRt1 = tmpDvswRt;

			//적용분담율
			this.bflDvswRt2 = this.sendParam1.aplDvswRt;

			this.bflRpymAmt1 = this.sendParam1.rpymAmt;

			this.bflRpymAmt2 = this.sendParam1.aplRpymAmt;
		},
		sendParam2(newValue, oldValue) {
			//console.log('.>>>>>>>', this.sendParam2);

			this.aplCpnyCd = this.sendParam2.cpnyCd;
			this.aplCpnyNm = this.sendParam2.cpnyNm;

			//확정 협력사 실납품사
			this.aplDlvgNm = this.sendParam2.dlvgNm;
			//확정 협력사 원인부품번호
			this.aplCausPartNo = this.sendParam2.partNo;
			this.aplCausPartNm = this.sendParam2.partNm;

			//분담율/귀책율
			this.aplDvswRt1 = 0;

			//변제금액
			this.aplRpymAmt1 = 0;

			//적용 분담율/귀책율
			this.aplDvswRt2 = 0;

			//적용변제금액
			/* 
			//원래는 분담율 적용분담율 변제금, 적용변제금액을 계산해서 가지고 오는데 요건이 변동됨에 따라 
		    //분담율, 적용분담율, 변제금액은 0으로 적용변제금액은 협력사 적용변제금액으로 넣는다. 나중에 키인으로 바뀜
			//딜러점
			this.aplCpnyCd = this.sendParam2.cpnyCd;
			this.aplCpnyNm = this.sendParam2.cpnyNm;

			let tmpDvswRt = this.sendParam2.rtsh;

			//분담율/귀책율
			this.aplDvswRt1 = tmpDvswRt;

			//변제금액
			this.aplRpymAmt1 = this.sendParam2.rpymAmt;
			
			//적용 분담율/귀책율
			this.aplDvswRt2 = tmpDvswRt;
			
			//적용변제금액
			this.aplRpymAmt2 = this.sendParam2.aplRpymAmt;

			
			//확정 협력사 실납품사
			this.aplDlvgNm = this.sendParam2.dlvgNm;
			//확정 협력사 원인부품번호
			this.aplCausPartNo = this.sendParam2.partNo;
			this.aplCausPartNm = this.sendParam2.partNm;
			*/
		},

		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateClamSave_({ key: 'clmNo', value: convertNvl(this.clmNo, '') }); // 클레임번호
				this.setStateClamSave_({ key: 'nos', value: convertNvl(this.nos, '') }); // 차수
				this.setStateClamSave_({ key: 'mkobType', value: convertNvl(this.mkobType, '') }); //이의제기타입
				this.setStateClamSave_({ key: 'mkobRson', value: convertNvl(this.mkobRson, '') }); //이의제기사유
				this.setStateClamSave_({ key: 'tgrpYn', value: convertNvl(this.tgrpYn, '') }); //클레임 변제대상

				this.setStateClamSave_({ key: 'bflCpnyCd', value: convertNvl(this.bflCpnyCd, '') }); // 협력사
				this.setStateClamSave_({ key: 'bflCpnyNm', value: convertNvl(this.bflCpnyNm, '') }); // 협력사명

				this.setStateClamSave_({ key: 'bflDvswRt1', value: convertNvl(this.bflDvswRt1, '') }); // 협력사 분담율

				this.setStateClamSave_({ key: 'bflDvswRt2', value: convertNvl(this.bflDvswRt2, '') }); // 협력사 적용분담율

				this.setStateClamSave_({ key: 'bflRpymAmt1', value: convertNvl(this.bflRpymAmt1, '') }); // 협력사 변제금액
				this.setStateClamSave_({ key: 'bflRpymAmt2', value: convertNvl(this.bflRpymAmt2, '') }); // 협력사 적용 변제금액

				this.setStateClamSave_({ key: 'aplCpnyCd', value: convertNvl(this.aplCpnyCd, '') }); // 확정 협력사
				this.setStateClamSave_({ key: 'aplCpnyNm', value: convertNvl(this.aplCpnyNm, '') }); // 확정 협력사명

				this.setStateClamSave_({ key: 'aplDvswRt1', value: convertNvl(this.aplDvswRt1, '') }); // 확정 협력사 분담율
				this.setStateClamSave_({ key: 'aplDvswRt2', value: convertNvl(this.aplDvswRt2, '') }); // 확정 협력사 적용분담율

				this.setStateClamSave_({ key: 'aplRpymAmt1', value: convertNvl(this.aplRpymAmt1, '') }); // 확정 협력사 변제금액

				this.setStateClamSave_({ key: 'aplRpymAmt2', value: convertNvl(this.aplRpymAmt2, '') }); // 확정 협력사 적용 변제금액
				this.setStateClamSave_({ key: 'aplCausPartNo', value: convertNvl(this.aplCausPartNo, '') }); // 확정 협력사 원인부품번호

				this.setStateClamSave_({ key: 'rmk', value: convertNvl(this.rmk, '') }); // 비고
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
